module.exports = __webpack_public_path__ + "static/img/xuezhanmajiang.afdba80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/xuezhanmajiang.jpg
// module id = iyji
// module chunks = 0